export const MAX_SUBITEM_DEPTH = 2;
